import { render, staticRenderFns } from "./MentoringMentors.vue?vue&type=template&id=19cb0702&scoped=true&"
import script from "./MentoringMentors.vue?vue&type=script&lang=js&"
export * from "./MentoringMentors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cb0702",
  null
  
)

export default component.exports